<template>
<div class="tenancy-container">

  <ToolBar
    :handleToolSide="handleToolSide"
    :handleToolHeadBtn="handleToolHeadBtn"
    :title="title"
    :toolbarIcon="toolbarIcon"
    :toolbarColor="toolbarColor"
    :isLoading="isLoading"
    >
      <v-spacer></v-spacer>
  </ToolBar>

      <v-container>
        <v-layout>
        <v-flex xs12 md8>
          <v-card flat>
            <DataForm
              :fields="doc.list.search"
              :form="search"
              :updateField="updateSearchField"
              :inPopup="true"
            />
            <v-card-actions>
              <v-btn @click="handleSearchReset">
                <v-icon left>refresh</v-icon>
                Recommencer
              </v-btn>
              <v-spacer />
              <v-btn color="primary" @click="handleSearch">
                <v-icon left>search</v-icon>
                Calculer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
          <v-flex xs12 md4>
            <v-card>
              <v-progress-linear indeterminate v-if="isLoading"/>
              <v-card-title primary-title>
              <div>
                <h2 class="display-2 mb-0">{{ data.value }}</h2>
              </div>
            </v-card-title>
              <v-divider/>
              <v-card-text class="text-center">
                <div class="tenancy-details"><em>Faces trouvées:</em><strong>{{data.count}}</strong></div>
              </v-card-text>
              <v-divider/>
              <v-card-actions>
                <v-btn flat @click="handleExport('pdf')">PDF</v-btn>
                <v-btn flat @click="handleExport('xls')">Excel</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

</div>
</template>

<script>
import ToolBar from '@/components/ToolBar'
import ToolbarActions from '@/components/ToolbarActions'
import DataForm from '@/components/form/DataForm'
import { filterActions } from '@/utils'

export default {
  components: {
    ToolBar,
    ToolbarActions,
    DataForm,
  },
  data: () => ({
    toolbarColor: 'green darken-4',
    toolbarIcon: 'chevron_left',
    title: "Taux d'occupation",
    source: 'tenancy',
  }),
  computed: {
    isLoading () { return this.$store.getters[`${this.source}/isLoading`] },
    doc () { return this.$store.getters[`${this.source}/doc`] },
    data () { return this.$store.getters[`${this.source}/data`] },
    scope () { return this.$store.getters['auth/scope'] },
    search () { return this.$store.getters[`${this.source}/search`] },
    searchDialog () { return this.search.dialog },
    listContext () {
      return {
        params: {
          ...this.doc.params.fetchAll,
          ...this.search.data,
        },
      }
    },
    listActions () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      let filtered = filterActions(this.doc.list.actions, {}, this.scope)
      return filtered.map(action => ({
        ...action,
        callBack: () => { this.$store.dispatch(action.dispatch, payload) },
      }))
    },
  },
  methods: {
    handleToolSide () {
      let payload = {
        accessors: {},
        context: this.formContext,
        data: {},
      }
      this.$store.dispatch('ui/toggleDrawer', payload)
    },
    handleToolHeadBtn () {
      this.$router.go(-1)
    },
    updateSearchField (data) {
      let payload = {
        accessors: {},
        context: this.listContext,
        data,
      }
      this.$store.dispatch(`${this.source}/updateSearchField`, payload)
    },
    handleSearch () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: this.search.data,
      }
      this.$store.dispatch(`${this.source}/search`, payload)
      this.handleSearchClose()
    },
    handleExport (format) {
      let payload = {
        accessors: {},
        context: {...this.listContext, format},
        data: this.search.data,
      }
      this.$store.dispatch(`${this.source}/export`, payload)
    },
    handleSearchClose () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      this.$store.dispatch(`${this.source}/closeSearch`, payload)
    },
    handleSearchReset () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      this.$store.dispatch(`${this.source}/resetSearch`, payload)
    },
  },
}
</script>
<style>
  .basesingle-container {
    position: relative;
    height: 100%;
    width: 100%;
  }
  .tenancy-container .input-group__details {
    min-height: 1px !important;
  }
  .tenancy-details {
    color: #777;
  }
  .tenancy-details em {
    margin-right: 5px
  }
</style>
